window.addEventListener("load", function () {
 

  var tabLinks = document.querySelectorAll("div.tabs ul.tabNavigation a");
  tabLinks.forEach((link, index) => {
    link.classList.toggle("selected", index === 0);
    link.addEventListener("click", function (e) {
      e.preventDefault();
      tabContainers.forEach(tab => tab.style.display = "none");
      document.querySelector(this.hash).style.display = "block";
      tabLinks.forEach(tab => tab.classList.remove("selected"));
      this.classList.add("selected");

      var swiperContainer = document.querySelector(this.hash + " .swiper3");
      if (swiperContainer && !swiperContainer.classList.contains("swiper-initialized")) {
        new Swiper(swiperContainer, {
          loop: false,
          slidesPerView: "auto",
          spaceBetween: 24,
          navigation: {
            nextEl: swiperContainer.closest(".tab-content").querySelector(".slider-nav .next"),
            prevEl: swiperContainer.closest(".tab-content").querySelector(".slider-nav .prev"),
          },
        });
      }
    });
  });

  var firstSwiperContainer = document.querySelectorAll("div.tabs div.tab-content")[0].querySelector('.swiper3');
  if (firstSwiperContainer) {
    new Swiper(firstSwiperContainer, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 24,
      navigation: {
        nextEl: firstSwiperContainer.closest(".tab-content").querySelector(".slider-nav .next"),
        prevEl: firstSwiperContainer.closest(".tab-content").querySelector(".slider-nav .prev")
      },
    });
  }

  new Swiper(".swiper2", { loop: true, slidesPerView: "auto", spaceBetween: 30, centeredSlides: true });
  new Swiper(".swiper5", { loop: true, breakpoints: { 1: { slidesPerView: "auto", spaceBetween: 15 }, 576: { slidesPerView: 2, spaceBetween: 32 }, 1230: { slidesPerView: 3, spaceBetween: 32 } } });
  // new Swiper(".swiper6", { loop: true, breakpoints: { 1: { slidesPerView: "auto", spaceBetween: 15, centeredSlides: true }, 576: { slidesPerView: 1, spaceBetween: 26, centeredSlides: false }, 768: { slidesPerView: 2, spaceBetween: 26, centeredSlides: false }, 1230: { slidesPerView: 3, spaceBetween: 26, centeredSlides: false }, 1760: { slidesPerView: 4, spaceBetween: 26, centeredSlides: false } } });
  new Swiper(".swiper7", { loop: true, breakpoints: { 1: { slidesPerView: "auto" }, 576: { slidesPerView: 2 }, 1230: { slidesPerView: 3 } } });
});

var tabContainers = document.querySelectorAll("div.tabs > div.tab-content");
tabContainers.forEach((tab, index) => {
  tab.style.display = index === 0 ? "block" : "none";
});

